import { $getSelection, $isRangeSelection, NodeKey } from "lexical";
import { $isRawHtmlTableCellNode, RawHtmlTableCellNode } from "./RawHtmlTableCellNode";
import { $isRawHtmlTableNode, RawHtmlTableNode } from "./RawHtmlTableNode";
import { $findParent } from "../utilities";

export function $getRawHtmlTableCellsFromSelection(): RawHtmlTableCellNode[]
{
    const selection = $getSelection();

    if (!selection) { return []; }

    const nodes = selection.getNodes();
    const sourceNodes = nodes.length > 0 ? [...nodes] : [];

    if (sourceNodes.length === 0 && $isRangeSelection(selection))
    {
        sourceNodes.push(selection.anchor.getNode());
    }

    const cells = new Set<RawHtmlTableCellNode>();

    for (const node of sourceNodes)
    {
        const cell = $findParent(node, $isRawHtmlTableCellNode);
        if (cell) { cells.add(cell); }
    }

    return [...cells];
}

export function $getRawHtmlTableFromSelection(): RawHtmlTableNode | null
{
    const cells = $getRawHtmlTableCellsFromSelection();
    if (cells.length > 0) { return $findParent(cells[0], $isRawHtmlTableNode); }
    const selection = $getSelection();
    if (!selection || !$isRangeSelection(selection)) { return null; }
    return $findParent(selection.anchor.getNode(), $isRawHtmlTableNode);
}

export type RawHtmlTableSelectionContext =
{
    tableKey: NodeKey
    cellKeys: NodeKey[]
}

export function $getRawHtmlTableSelectionContext(): RawHtmlTableSelectionContext | null
{
    const table = $getRawHtmlTableFromSelection();

    if (!table) { return null; }

    const cells = $getRawHtmlTableCellsFromSelection();

    return {
        tableKey: table.getKey(),
        cellKeys: cells.map(cell => cell.getKey()),
    };
}